export default __webpack_public_path__ + "static/media/email.16588044.svg";